"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../../../CTAs/Button"));

var _IconSearch = _interopRequireDefault(require("../../../Icons/IconSearch"));

var _composeRefs = _interopRequireDefault(require("../../../utils/composeRefs"));

var _createUniqueElementIds = require("../../../utils/createUniqueElementIds/createUniqueElementIds");

var _DescriptionMessages = _interopRequireDefault(require("../DescriptionMessages"));

var _InputLabel = _interopRequireDefault(require("../InputLabel"));

var _SuggestionsList = _interopRequireDefault(require("../SuggestionsList"));

var _inputFieldFormattingUtils = require("./inputFieldFormattingUtils");

var _excluded = ["ariaLabel", "ariaLabelledBy", "autoCapitalize", "autoComplete", "autoCorrect", "autoFormat", "autoFormatOnFill", "buttonOnClick", "classes", "dataTestId", "description", "descriptionId", "enterkeyhint", "errorMessages", "formControlId", "handleCustomAutoFormat", "handleOnBlurValidation", "handleOnChange", "handleOnChangeValidation", "handleOnKeyDown", "handleOnKeyPress", "hidePasswordButtonAriaLabel", "hidePasswordButtonText", "initialValue", "inputFieldButtonRef", "inputFieldButtonTestId", "inputId", "inputMode", "isDescriptionHtml", "isDisabled", "isOptional", "isRequired", "isValid", "isCleared", "label", "labelId", "maxLength", "minLength", "name", "pattern", "placeholder", "showInputFieldButton", "showPasswordButtonAriaLabel", "showPasswordButtonText", "showInputValueOnMount", "size", "spellcheck", "suggestions", "type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputField = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelledBy = _ref.ariaLabelledBy,
      autoCapitalize = _ref.autoCapitalize,
      autoComplete = _ref.autoComplete,
      autoCorrect = _ref.autoCorrect,
      autoFormat = _ref.autoFormat,
      autoFormatOnFill = _ref.autoFormatOnFill,
      buttonOnClick = _ref.buttonOnClick,
      classes = _ref.classes,
      dataTestId = _ref.dataTestId,
      description = _ref.description,
      descriptionId = _ref.descriptionId,
      enterkeyhint = _ref.enterkeyhint,
      errorMessages = _ref.errorMessages,
      formControlId = _ref.formControlId,
      handleCustomAutoFormat = _ref.handleCustomAutoFormat,
      handleOnBlurValidation = _ref.handleOnBlurValidation,
      handleOnChange = _ref.handleOnChange,
      handleOnChangeValidation = _ref.handleOnChangeValidation,
      handleOnKeyDown = _ref.handleOnKeyDown,
      handleOnKeyPress = _ref.handleOnKeyPress,
      hidePasswordButtonAriaLabel = _ref.hidePasswordButtonAriaLabel,
      hidePasswordButtonText = _ref.hidePasswordButtonText,
      initialValue = _ref.initialValue,
      inputFieldButtonRef = _ref.inputFieldButtonRef,
      inputFieldButtonTestId = _ref.inputFieldButtonTestId,
      inputId = _ref.inputId,
      inputMode = _ref.inputMode,
      isDescriptionHtml = _ref.isDescriptionHtml,
      isDisabled = _ref.isDisabled,
      isOptional = _ref.isOptional,
      isRequired = _ref.isRequired,
      isValid = _ref.isValid,
      isCleared = _ref.isCleared,
      label = _ref.label,
      labelId = _ref.labelId,
      maxLength = _ref.maxLength,
      minLength = _ref.minLength,
      name = _ref.name,
      pattern = _ref.pattern,
      placeholder = _ref.placeholder,
      showInputFieldButton = _ref.showInputFieldButton,
      showPasswordButtonAriaLabel = _ref.showPasswordButtonAriaLabel,
      showPasswordButtonText = _ref.showPasswordButtonText,
      showInputValueOnMount = _ref.showInputValueOnMount,
      size = _ref.size,
      spellcheck = _ref.spellcheck,
      suggestions = _ref.suggestions,
      type = _ref.type,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var inputFieldButtonWrapperRef = (0, _react.useRef)(null);
  var altInputRef = (0, _react.useRef)(null);
  var inputFieldRef = (0, _react.useRef)(null);
  var suggestionsListRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(isCleared),
      _useState4 = _slicedToArray(_useState3, 2),
      clearInput = _useState4[0],
      setClearInput = _useState4[1];

  var _useState5 = (0, _react.useState)(value),
      _useState6 = _slicedToArray(_useState5, 2),
      prevValue = _useState6[0],
      setPrevValue = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isInputHovered = _useState8[0],
      setIsInputHovered = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isInputFocused = _useState10[0],
      setIsInputFocused = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isButtonFocused = _useState12[0],
      setIsButtonFocused = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      inputHasFocusIntent = _useState14[0],
      setInputHasFocusIntent = _useState14[1];

  var _useState15 = (0, _react.useState)(showInputValueOnMount),
      _useState16 = _slicedToArray(_useState15, 2),
      inputValueIsVisible = _useState16[0],
      setInputValueIsVisible = _useState16[1];

  var _useState17 = (0, _react.useState)(84),
      _useState18 = _slicedToArray(_useState17, 2),
      inputButtonWrapperWidth = _useState18[0],
      setInputButtonWrapperWidth = _useState18[1];

  var _useState19 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('label')),
      _useState20 = _slicedToArray(_useState19, 1),
      labelUniqueId = _useState20[0];

  var _useState21 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('input')),
      _useState22 = _slicedToArray(_useState21, 1),
      inputUniqueId = _useState22[0];

  var _useState23 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('description')),
      _useState24 = _slicedToArray(_useState23, 1),
      descriptionUniqueId = _useState24[0];

  var _useState25 = (0, _react.useState)(0),
      _useState26 = _slicedToArray(_useState25, 2),
      inputBlurCount = _useState26[0],
      setInputBlurCount = _useState26[1];

  var _useState27 = (0, _react.useState)(null),
      _useState28 = _slicedToArray(_useState27, 2),
      activeElement = _useState28[0],
      setActiveElement = _useState28[1];

  var _useState29 = (0, _react.useState)(false),
      _useState30 = _slicedToArray(_useState29, 2),
      showSuggestions = _useState30[0],
      setShowSuggestions = _useState30[1];

  var _useState31 = (0, _react.useState)([]),
      _useState32 = _slicedToArray(_useState31, 2),
      filteredSuggestions = _useState32[0],
      setFilteredSuggestions = _useState32[1];

  var _useState33 = (0, _react.useState)(0),
      _useState34 = _slicedToArray(_useState33, 2),
      activeSuggestionIndex = _useState34[0],
      setActiveSuggestionIndex = _useState34[1];

  var isPasswordType = type === 'password';
  var isSearchType = type === 'search';

  var handleSetValue = function handleSetValue(event) {
    return setValue(event.target.value);
  };

  var setProgrammaticValue = function setProgrammaticValue(pValue) {
    var input = document.querySelector("#".concat(inputId || inputUniqueId)); // This will work by calling the native setter bypassing Reacts incorrect value change check

    Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set.call(input, pValue); // This will trigger a new render for the component

    input.dispatchEvent(new Event('change', {
      bubbles: true
    }));
  };

  var handleFormatting = function handleFormatting() {
    switch (autoFormat) {
      case 'card':
        setValue((0, _inputFieldFormattingUtils.formatCardInput)(value));
        setProgrammaticValue((0, _inputFieldFormattingUtils.formatCardInput)(value));
        break;

      case 'currency':
        setValue((0, _inputFieldFormattingUtils.formatCurrencyInput)(value));
        setProgrammaticValue((0, _inputFieldFormattingUtils.formatCurrencyInput)(value));
        break;

      case 'ssn':
        setValue((0, _inputFieldFormattingUtils.formatSSNInput)(value));
        setProgrammaticValue((0, _inputFieldFormattingUtils.formatSSNInput)(value));
        break;

      case 'phone':
        setValue((0, _inputFieldFormattingUtils.formatPhoneInput)(value));
        setProgrammaticValue((0, _inputFieldFormattingUtils.formatPhoneInput)(value));
        break;

      case 'custom':
        setValue(handleCustomAutoFormat(value));
        setProgrammaticValue(handleCustomAutoFormat(value));
        break;

      default:
        setValue(value);
        break;
    }
  };

  var resetInputField = function resetInputField() {
    setValue('');
  };

  var inputFieldButtonAriaLabel = function inputFieldButtonAriaLabel() {
    return inputValueIsVisible ? hidePasswordButtonAriaLabel : showPasswordButtonAriaLabel;
  };

  var inputFieldButtonText = function inputFieldButtonText() {
    return inputValueIsVisible ? hidePasswordButtonText : showPasswordButtonText;
  }; // Search Input Functionality


  var handleAutoSuggestOnChange = function handleAutoSuggestOnChange(e) {
    var userInput = e.target.value; // Filter the suggestions list to only include suggestions that match the user's input

    var matchedSuggestions = suggestions.filter(function (suggestion) {
      return suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1;
    });
    setShowSuggestions(true);
    setFilteredSuggestions(matchedSuggestions);
    setActiveSuggestionIndex(-1); // sets index as negative one so there are no suggestions selected initially.
  };

  var handleSuggestionOnClick = function handleSuggestionOnClick(e) {
    setValue(e.currentTarget.innerHTML);
    setProgrammaticValue(e.currentTarget.innerHTML);
    setActiveSuggestionIndex(0);
    setFilteredSuggestions([]);
  };

  var handleSuggestionOnKeyDown = function handleSuggestionOnKeyDown(e) {
    if (e.key === 'Enter') {
      // enter key
      e.preventDefault(); // Only set value to filtered selection if explicitly selected from the list,
      // otherwise set value to what was typed into the search field.

      if (activeSuggestionIndex > -1) {
        setValue(filteredSuggestions[activeSuggestionIndex]);
        setProgrammaticValue(filteredSuggestions[activeSuggestionIndex]);
      } else {
        setValue(value);
      }

      setActiveSuggestionIndex(0);
      setFilteredSuggestions([]);
    } else if (e.key === 'ArrowUp') {
      // up arrow
      e.preventDefault();

      if (activeSuggestionIndex > 0) {
        setActiveSuggestionIndex(activeSuggestionIndex - 1);
        setValue(filteredSuggestions[activeSuggestionIndex - 1]); // TODO:
      } else {
        return null;
      }
    } else if (e.key === 'ArrowDown') {
      // down arrow
      if (activeSuggestionIndex + 1 !== filteredSuggestions.length) {
        setActiveSuggestionIndex(activeSuggestionIndex + 1);
        setValue(filteredSuggestions[activeSuggestionIndex + 1]); // TODO:
      } else {
        return null;
      }
    } else if (e.key === 'Tab') {
      // tab
      setActiveSuggestionIndex(0);
      setShowSuggestions(false);
      setFilteredSuggestions([]); // TODO:
    }

    return null;
  };

  var hasSearchSuggestions = isSearchType && value && showSuggestions && filteredSuggestions.length > 0;
  var formControlStyles = (0, _classnames.default)('form-control__container', {
    'form-control__container--error': !isValid
  }, classes);
  var inputFieldWrapperStyles = (0, _classnames.default)('form-control__input-wrapper', {
    'form-control__input-wrapper--small': size === 'small',
    'form-control__input-wrapper--is-disabled': isDisabled,
    'form-control__input-wrapper--is-focused': isInputFocused,
    'form-control__input-wrapper--is-hovered': isInputHovered,
    'form-control__input-wrapper--has-error': !isValid,
    'form-control__input-wrapper--has-value': value.length > 0,
    'form-control__input-wrapper--currency': autoFormat === 'currency',
    'form-control__input-wrapper--search': type === 'search'
  });
  var inputFieldStyles = (0, _classnames.default)('form-control__input', {
    'form-control__input--error': !isValid,
    'form-control__input--small': size === 'small'
  }); // ------------------------------------------------
  //  INPUT ELEMENT EVENT HANDLERS
  // ------------------------------------------------

  var handleInputBlur = function handleInputBlur() {
    setIsInputFocused(false);
    setInputBlurCount(inputBlurCount + 1);
  };

  var handleInputFocus = function handleInputFocus() {
    setIsInputFocused(true);
  }; // ------------------------------------------------
  // BUTTON ELEMENT EVENT HANDLERS
  // ------------------------------------------------


  var handleButtonBlur = function handleButtonBlur() {
    setIsButtonFocused(false);
  };

  var handleButtonFocus = function handleButtonFocus() {
    setIsButtonFocused(true);
  };

  var handleButtonClick = function handleButtonClick() {
    if (isPasswordType) {
      setInputValueIsVisible(!inputValueIsVisible);
    }

    if (isSearchType) {
      resetInputField();
    }

    setInputButtonWrapperWidth(Math.ceil(inputFieldButtonWrapperRef.current && inputFieldButtonWrapperRef.current.getBoundingClientRect().width));
    if (buttonOnClick) buttonOnClick();
  }; // ------------------------------------------------
  // SIDE EFFECTS
  // ------------------------------------------------
  // Set if input is focused or not


  (0, _react.useEffect)(function () {
    var _inputFieldRef$curren;

    if (inputFieldRef !== null && inputFieldRef !== void 0 && (_inputFieldRef$curren = inputFieldRef.current) !== null && _inputFieldRef$curren !== void 0 && _inputFieldRef$curren.contains(activeElement)) {
      setInputHasFocusIntent(true);
    } else {
      setInputHasFocusIntent(false);
    }
  }, [activeElement]); // Sets the active element to state if the input or input field button are focused

  (0, _react.useEffect)(function () {
    setActiveElement(document.activeElement);
  }, [isButtonFocused, isInputFocused]); // Sets the value of the password and SSN inputs to hidden/obscured on blur

  (0, _react.useEffect)(function () {
    // Assume whole component is blurred when !inputHasFocusIntent
    if (!inputHasFocusIntent) {
      if (value && inputBlurCount > 0) setInputValueIsVisible(false);
    }
  }, [inputHasFocusIntent]); // Toggles the password and SSN inputs between clear text and hidden/obscured on input field button action

  (0, _react.useEffect)(function () {
    // [ 1234 "Hide"] <- when inputValueIsVisible === true
    // [ •••• "Show"] <- when inputValueIsVisible === false
    if (value && inputValueIsVisible) {
      altInputRef.current.focus();
      altInputRef.current.setSelectionRange(value.length, value.length);
    }
  }, [inputValueIsVisible]);
  (0, _react.useEffect)(function () {
    if (handleOnChangeValidation) handleOnChangeValidation(value);

    if (autoFormatOnFill) {
      // format when browser autofill or paste from clipboard
      setPrevValue(value);

      if (autoFormat && Math.abs(value.length - prevValue.length) > 1) {
        handleFormatting();
      }
    }

    if (value.length >= 1) {
      setClearInput(false);
    } else if (value.length === 0) {
      setClearInput(true);
    }
  }, [value]); // Closes the search input suggestions list when click event is outside of the list

  (0, _react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (inputFieldRef.current && !inputFieldRef.current.contains(event.target) && suggestionsListRef.current && !suggestionsListRef.current.contains(event.target)) {
        setFilteredSuggestions([]);
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return function () {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
  (0, _react.useEffect)(function () {
    setValue(initialValue);
  }, [initialValue]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: formControlStyles,
    id: formControlId
  }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    inputId: inputId,
    inputUniqueId: inputUniqueId,
    isDisabled: isDisabled,
    isOptional: isOptional,
    isValid: isValid,
    label: label,
    labelId: labelId,
    labelUniqueId: labelUniqueId,
    type: type
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: inputFieldWrapperStyles,
    ref: inputFieldRef
  }, isSearchType && /*#__PURE__*/_react.default.createElement(_IconSearch.default, null), /*#__PURE__*/_react.default.createElement("input", _extends({
    id: inputId || inputUniqueId,
    name: name,
    type: inputValueIsVisible ? 'text' : type,
    value: value,
    onBlur: function onBlur() {
      handleInputBlur();

      if (handleOnBlurValidation) {
        handleOnBlurValidation(value);
      }

      if (autoFormat) handleFormatting();
    },
    onChange: function onChange(event) {
      handleSetValue(event);

      if (isSearchType) {
        handleAutoSuggestOnChange(event);
      }

      if (handleOnChange) {
        handleOnChange(event);
      }
    },
    onFocus: handleInputFocus,
    onMouseEnter: function onMouseEnter() {
      return setIsInputHovered(!isInputHovered);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsInputHovered(!isInputHovered);
    },
    onKeyPress: handleOnKeyPress,
    onKeyDown: function onKeyDown(event) {
      if (hasSearchSuggestions) {
        handleSuggestionOnKeyDown(event);
      }

      if (handleOnKeyDown) {
        handleOnKeyDown();
      }
    },
    role: suggestions.length > 0 ? 'combobox' : null,
    "aria-expanded": suggestions.length > 0 || showSuggestions ? !!hasSearchSuggestions : null,
    "aria-autocomplete": suggestions.length > 0 ? 'list' : null,
    "aria-controls": suggestions.length > 0 ? 'listBoxId' : null,
    inputMode: inputMode,
    autoComplete: autoComplete,
    autoCorrect: autoCorrect,
    autoCapitalize: autoCapitalize,
    required: isPasswordType || isRequired || null,
    disabled: isDisabled || null,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(labelId || labelUniqueId) : null,
    "aria-disabled": isDisabled || null,
    "aria-required": isPasswordType || isRequired || null,
    "aria-invalid": !isValid || null,
    "aria-describedby": (description || errorMessages && !isValid) && (descriptionId || descriptionUniqueId) || null,
    enterKeyHint: enterkeyhint,
    placeholder: placeholder,
    minLength: minLength,
    maxLength: maxLength,
    className: inputFieldStyles,
    pattern: pattern,
    spellCheck: spellcheck,
    ref: (0, _composeRefs.default)(ref, altInputRef) || null,
    style: (isPasswordType || showInputFieldButton) && {
      paddingRight: "".concat(inputButtonWrapperWidth, "px")
    } || null,
    "data-testid": dataTestId
  }, additionalProps)), isSearchType && !isDisabled && /*#__PURE__*/_react.default.createElement("div", {
    className: "form-control__input-cta-wrapper ".concat(clearInput === true ? 'form-control__input-cta-wrapper--is-cleared' : 'form-control__input-cta-wrapper--clear-button'),
    ref: inputFieldButtonWrapperRef
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    icon: "IconClose",
    variant: "text-alternate",
    size: "small",
    type: "button",
    classes: "cta--text-alternate ".concat(size === 'small' ? 'cta--icon-only-small' : ''),
    clickMethod: handleButtonClick,
    focusMethod: handleButtonFocus,
    blurMethod: handleButtonBlur,
    ariaLabel: "Clear Search",
    ref: inputFieldButtonRef,
    dataTestId: inputFieldButtonTestId
  })), (showInputFieldButton || isPasswordType) && !isDisabled && /*#__PURE__*/_react.default.createElement("div", {
    className: "form-control__input-cta-wrapper ".concat(size === 'small' ? 'form-control__input-cta-wrapper--is-small' : ''),
    ref: inputFieldButtonWrapperRef
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text-secondary",
    size: "small",
    type: "button",
    text: inputFieldButtonText(),
    clickMethod: handleButtonClick,
    focusMethod: handleButtonFocus,
    blurMethod: handleButtonBlur,
    ariaLabel: inputFieldButtonAriaLabel(),
    ref: inputFieldButtonRef,
    dataTestId: inputFieldButtonTestId
  }))), (description || errorMessages.length > 0 && !isValid) && /*#__PURE__*/_react.default.createElement(_DescriptionMessages.default, {
    description: description,
    descriptionId: descriptionId,
    descriptionUniqueId: descriptionUniqueId,
    errorMessages: errorMessages,
    isDescriptionHtml: isDescriptionHtml,
    isDisabled: isDisabled,
    isValid: isValid
  }), hasSearchSuggestions && /*#__PURE__*/_react.default.createElement(_SuggestionsList.default, {
    activeSuggestionIndex: activeSuggestionIndex,
    filteredSuggestions: filteredSuggestions,
    handleSuggestionOnClick: handleSuggestionOnClick,
    showSuggestions: showSuggestions,
    size: size,
    ref: suggestionsListRef
  }));
}); // needed for prop type checking refs in server side rendered apps

var Element = typeof Element === 'undefined' ? function () {} : Element; // eslint-disable-line

InputField.displayName = 'InputField';
InputField.propTypes = {
  /**
   Optional. Adds aria-label attribute to the input with the entered string.
   */
  ariaLabel: _propTypes.default.string,

  /**
   Optional. Adds `aria-labelledby` attribute to associate the input with a page level error message.
   */
  ariaLabelledBy: _propTypes.default.string,

  /**
   Optional. Controls how the text input value is automatically capitalized via virtual keyboards and voice input.
   */
  autoCapitalize: _propTypes.default.oneOf(['on', 'off', 'none', 'sentences', 'words', 'characters']),

  /**
   Optional. Allows the user agent to provide assistance in filling out form field values by hinting or suggesting values to the user. Also helps the browser know what type of info to expect. For a password input, this should be set to either "current-password" or "new-password".
   */
  autoComplete: (0, _reactRequiredIf.default)(_propTypes.default.oneOf(['off', 'on', 'name', 'honorific-prefix', 'given-name', 'additional-name', 'family-name', 'honorific-suffix', 'nickname', 'email', 'username', 'new-password', 'current-password', 'one-time-code', 'organization-title', 'organization', 'street-address', 'address-line1', 'address-line2', 'address-line3', 'address-level4', 'address-level3', 'address-level4', 'address-level1', 'country', 'country-name', 'postal-code', 'cc-name', 'cc-given-name', 'cc-additional-name', 'cc-family-name', 'cc-number', 'cc-exp', 'cc-exp-month', 'cc-exp-year', 'cc-csc', 'cc-type', 'transaction-currency', 'transaction-amount', 'language', 'bday', 'bday-day', 'bday-month', 'bday-year', 'tel', 'tel-extension', 'impp', 'url', 'photo']), function (props) {
    return props.type === 'password' && props.autoFormat === null;
  }),

  /**
   Optional. A Safari extension that indicates whether or not to activate automatic correction while the user is editing the field.
   */
  autoCorrect: _propTypes.default.oneOf(['on', 'off']),

  /**
   Optional. Declares which type of auto-formatting to add to the input. If `custom` is used you must provide a function via the `handleCustomAutoFormat` prop.
   */
  autoFormat: _propTypes.default.oneOf(['card', 'currency', 'ssn', 'phone', 'custom']),

  /**
   Optional. Will format the input value on change when the field is filled via browser autofill or user paste from clipboard.
   */
  autoFormatOnFill: _propTypes.default.bool,

  /**
   Optional. Function passed to the form control CTA. Defaults to `null`.
   */
  buttonOnClick: _propTypes.default.func,

  /**
   Optional. String to add custom class(es) to the form control container.
   */
  classes: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the element for use in testing scenarios. Defaults to `null`.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. Custom description that appears below the checkbox. Can be a string or a React component (object).
   */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),

  /**
   Optional. A unique identifier passed to the description's `id` attribute. Defaults to `null`.
   */
  descriptionId: _propTypes.default.string,

  /**
   Optional. Defines what action label to present for the enter key on virtual keyboards.
   */
  enterkeyhint: _propTypes.default.oneOf(['enter', 'done', 'open', 'next', 'previous', 'search', 'send']),

  /**
   Optional. Array of error message strings displayed when `isValid` is `false`.
   */
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   Optional. A unique identifier passed to the component wrapper's `id` attribute. Defaults to `null`.
   */
  formControlId: _propTypes.default.string,

  /**
   * Required if `autoFormat="custom"`. A function passed to the input for formatting the input value. The value for the input must be passed in (`(v) => formatCallback(v)`).
   */
  handleCustomAutoFormat: (0, _reactRequiredIf.default)(_propTypes.default.func, function (props) {
    return props.autoFormat === 'custom';
  }),

  /**
   Optional. A function passed in to validate the input value on blur. The value for the input must be passed in (`(v) => formatCallback(v)`) and will update when the input is blurred.
   */
  handleOnBlurValidation: _propTypes.default.func,

  /**
   Optional, but required for controlled inputs. The function passed to the input's `onChange` method.
   */
  handleOnChange: _propTypes.default.func,

  /**
   Optional. A function passed in to validate the input value on change. The value for the input must be passed in (`(v) => formatCallback(v)`) and will update when the input's value is changed.
   */
  handleOnChangeValidation: _propTypes.default.func,

  /**
   Optional. The function passed to the input's `onKeyDown` method.
   */
  handleOnKeyDown: _propTypes.default.func,

  /**
   Optional. The function passed to the input's `onKeyPress` method.
   */
  handleOnKeyPress: _propTypes.default.func,

  /**
   Optional. Text for the password input show/hide toggle CTA aria-label. Defaults to 'Hide password'.
   */
  hidePasswordButtonAriaLabel: _propTypes.default.string,

  /**
   Optional. Text for the password input show/hide toggle CTA. Defaults to 'Hide'.
   */
  hidePasswordButtonText: _propTypes.default.string,

  /**
   Optional. Initial value of the input. Defaults to ''.
   */
  initialValue: _propTypes.default.string,

  /**
   Optional. React ref to be passed to the input label button element. Defaults to `null`.
   */
  inputFieldButtonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })]),

  /**
   * Optional. A unique identifier passed to the input field button for use in testing scenarios. Defaults to `'input-field-input-label-button'`.
   */
  inputFieldButtonTestId: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the input's `id` attribute. Defaults to `null`.
   */
  inputId: _propTypes.default.string,

  /**
   Optional. inputMode hints at the type of data that might be entered by the user while editing the element or its contents. This allows a browser to display an appropriate virtual keyboard. Defaults to `'text'`.
   */
  inputMode: _propTypes.default.oneOf(['none', 'text', 'decimal', 'numeric', 'tel', 'search', 'email', 'url']),

  /**
   Optional. Defaults true.
   */
  isCleared: _propTypes.default.bool,

  /**
   Optional. Used to pass HTML to the `description` prop. Defaults to `false`.
   */
  isDescriptionHtml: _propTypes.default.bool,

  /**
   Optional. Passes the `disabled` prop to the checkbox input. Defaults to `false`.
   */
  isDisabled: _propTypes.default.bool,

  /**
   Optional. Should not be used if `isRequired` is used. Adds "Optional" text to the right of the legend. Defaults to `false`.
   */
  isOptional: _propTypes.default.bool,

  /**
   Optional. Adds the `required` attribute to the input. Defaults to `false`.
   */
  isRequired: _propTypes.default.bool,

  /**
   Optional. Sets the error state for the input when set to `false`. Defaults to `true`.
   */
  isValid: _propTypes.default.bool,

  /**
   Required. The label that appears above the input.
   */
  label: _propTypes.default.string.isRequired,

  /**
   Optional. A unique identifier passed to the input label's `id` attribute. Defaults to `null`.
   */
  labelId: _propTypes.default.string,

  /**
   Optional. Sets the maximum number of characters the user can enter into the input. Defaults to `null`.
   */
  maxLength: _propTypes.default.number,

  /**
   Optional. Sets the minimum number of characters the user must enter into the input. Defaults to `null`.
   */
  minLength: _propTypes.default.number,

  /**
   Optional. Sets the `name` attribute for the input. Defaults to `null`.
   */
  name: _propTypes.default.string,

  /**
   Optional. RegEx string used for HTML5 validation on submit. Defaults to `null`.
   */
  pattern: _propTypes.default.string,

  /**
   Optional. Custom placeholder for input. Defaults to `null`.
   */
  placeholder: _propTypes.default.string,

  /**
   Optional. Passed if the CTA to the right of the input should be shown. Defaults to `false`.
   */
  showInputFieldButton: _propTypes.default.bool,

  /**
   Optional. Text for the password input show/hide toggle CTA. Defaults to 'Show password'.
   */
  showPasswordButtonAriaLabel: _propTypes.default.string,

  /**
    Optional. Text for the password input show/hide toggle CTA. Defaults to 'Show'.
    */
  showPasswordButtonText: _propTypes.default.string,

  /**
   Optional. Sets the initial state of `password` type inputs. Defaults to `false`.
   */
  showInputValueOnMount: _propTypes.default.bool,

  /**
   Optional. Controls the size of the box and label. Defaults to 'large'.
   */
  size: _propTypes.default.oneOf(['large', 'small']),

  /**
   Optional. Specifies whether the textarea is subject to spell checking by the browser or operating system.
   */
  spellcheck: _propTypes.default.oneOf(['true', 'false']),

  /**
   Optional. Controls the list of suggestions to be passed in.
   */
  suggestions: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   Optional. The value passed to the `type` attribute for the input. This is already set on most utility inputs and can only overridden on the Text Input component. Defaults to `'text'`.
   */
  type: _propTypes.default.oneOf(['email', 'password', 'search', 'tel', 'text', 'url'])
};
InputField.defaultProps = {
  ariaLabel: null,
  ariaLabelledBy: null,
  autoCapitalize: null,
  autoComplete: null,
  autoCorrect: 'off',
  autoFormat: null,
  autoFormatOnFill: false,
  buttonOnClick: null,
  classes: '',
  dataTestId: null,
  description: '',
  descriptionId: '',
  enterkeyhint: 'enter',
  errorMessages: [],
  formControlId: null,
  handleCustomAutoFormat: null,
  handleOnBlurValidation: function handleOnBlurValidation() {},
  handleOnChange: null,
  handleOnChangeValidation: function handleOnChangeValidation() {},
  handleOnKeyDown: function handleOnKeyDown() {},
  handleOnKeyPress: function handleOnKeyPress() {},
  hidePasswordButtonAriaLabel: 'Hide password',
  hidePasswordButtonText: 'Hide',
  initialValue: '',
  inputFieldButtonRef: null,
  inputFieldButtonTestId: 'input-field-input-label-button',
  inputId: null,
  inputMode: 'text',
  isDescriptionHtml: false,
  isDisabled: false,
  isOptional: false,
  isRequired: false,
  isValid: true,
  isCleared: true,
  labelId: null,
  maxLength: null,
  minLength: null,
  name: null,
  pattern: null,
  placeholder: null,
  showInputFieldButton: false,
  showPasswordButtonAriaLabel: 'Show password',
  showPasswordButtonText: 'Show',
  showInputValueOnMount: false,
  size: 'large',
  spellcheck: 'true',
  suggestions: [],
  type: 'text'
};
var _default = InputField;
exports.default = _default;